import {Divider} from "@hps/hops-react";
import {List, ListItemButton, ListItemText, SwipeableDrawer} from "@mui/material";
import {useLocation, useNavigate} from "react-router-dom";

import Routes from "Resources/Routes.json";


/**
 * Mobile navigation drawer
 */
const UiBarDrawer = ({navigationLinks, onClose, open, showFaqs}) => {

	const location = useLocation();
	const navigate = useNavigate();

	const handleItemClick = uri => {
		onClose();
		navigate(uri);
	};

	const hasItems = !!navigationLinks?.length || showFaqs;

	return (
		<SwipeableDrawer
			anchor="left"
			disableBackdropTransition={true}
			disableDiscovery={true}
			hysteresis={0.25}
			minFlingVelocity={250}
			onClose={onClose}
			onOpen={() => {}}
			open={open}
			slotProps={{paper: {style: {width: "24rem"}}}}
			swipeAreaWidth={15}>
			<List disablePadding={true}>
				{navigationLinks?.map((link, key) => (
					<ListItemButton
						key={key}
						onClick={() => handleItemClick(link.Uri)}
						selected={location.pathname.startsWith(link.Uri)}>
						<ListItemText primary={link.Label} />
					</ListItemButton>
				))}
				{showFaqs && (
					<ListItemButton
						onClick={() => handleItemClick(Routes.faqs)}
						selected={location.pathname.startsWith(Routes.faqs)}>
						<ListItemText primary="FAQs" />
					</ListItemButton>
				)}
				{hasItems && <Divider />}
			</List>
		</SwipeableDrawer>
	);

};

export default UiBarDrawer;
